import { Component, OnInit, ɵConsole ,Input } from '@angular/core';

@Component({
  selector: 'app-resume-check',
  templateUrl: './resume-check.component.html',
  styleUrls: ['./resume-check.component.sass']
})
export class ResumeCheckComponent implements OnInit {
  @Input() infoAfiliation;
  @Input() bank;
  @Input() affiliate;
  @Input() screen;
  constructor() { }

  ngOnInit() {
  }

}
